var _defs, _rect, _ellipse, _ellipse2, _ellipse3, _polygon, _polygon2, _rect2, _circle, _circle2, _path, _text, _rect3, _text2, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 260 1200 850",
    role: "img",
    "aria-label": "Cacambix",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tubGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCC366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F59E0B"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 260,
    width: 1200,
    height: 850,
    rx: 140,
    fill: "#FBF9F5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 470,
    cy: 500,
    rx: 95,
    ry: 58,
    fill: "#6B7280"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 620,
    cy: 465,
    rx: 115,
    ry: 68,
    fill: "#9CA3AF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 760,
    cy: 502,
    rx: 90,
    ry: 55,
    fill: "#4B5563"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "300,520 900,520 760,790 440,790",
    fill: "url(#tubGrad)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "900,520 940,542 792,812 760,790",
    fill: "#E2650B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 508,
    width: 600,
    height: 22,
    rx: 11,
    fill: "#FDE2AE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 772,
    r: 132,
    fill: "#FBF9F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 862,
    cy: 772,
    r: 110,
    fill: "#1B1748"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M808,774 L845,811 L920,730",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 955,
    textAnchor: "middle",
    fontFamily: "'Poppins','Roboto',sans-serif",
    fontWeight: 800,
    fontSize: 130
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#1B1748"
  }, "Cacamb"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#F59E0B"
  }, "ix"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 1028,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#F59E0B"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 1040,
    textAnchor: "middle",
    fontFamily: "'Roboto',sans-serif",
    fontWeight: 600,
    fontSize: 34,
    letterSpacing: 4,
    fill: "#1B1748"
  }, "SISTEMA DE GEST\xC3O DE CA\xC7AMBAS")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 902,
    y: 1028,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#F59E0B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98ee5c14df15651c1ada8a88dfe7c818.svg";
export { ForwardRef as ReactComponent };